// Interceptor para debugging de peticiones API
// Solo para logging, no modifica las peticiones
// Se puede habilitar con ?debug=true en la URL

const originalFetch = window.fetch;

window.fetch = function(url, options = {}) {
  // Solo loggear si está habilitado el debug mode
  const urlParams = new URLSearchParams(window.location.search);
  const debugMode = urlParams.get('debug') === 'true';
  
  if (debugMode && 
      typeof url === 'string' && 
      url.includes('localhost:8080')) {
    
    console.log('🌐 API Request:', url, options.method || 'GET');
  }
  
  return originalFetch(url, options);
};

const apiInterceptor = {};
export default apiInterceptor;
